import { computed, defineComponent, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { ProjectGetter } from '@/store/project/project.module';
import { Project, ApprovementForm } from '@/store/project/project.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';
import FormComponent from '@/components/project/create/createComponents/approvementForm/ApprovementForm.vue';

export default defineComponent({
  name: 'ApprovementFormComponent',
  components: {
    BaseModalComponent,
    FormComponent,
  },
  props: {
    projectId: {
      type: Number,
      required: true,
    },
  },
  emits: [
    'validated'
  ],
  setup: (props, context) => {
    const store = useStore();
    const approvementModal = ref<InstanceType<typeof BaseModalComponent>>();
    const form = ref<InstanceType<typeof FormComponent>>();
    const isLoading = computed<boolean>(() => store.getters[ProjectGetter.STATUS] === 'init' || store.getters[ProjectGetter.STATUS] === 'loading');

    const project = computed<Project | undefined>(() => store.getters[ProjectGetter.BY_ID](props.projectId));
    const approvementForm = reactive<ApprovementForm>({
      fiscalYearId: project.value?.fiscalYear.id,
      cabinetMinisterId: project.value?.projectApprovement?.id,
      approvedDate: project.value?.projectApprovement?.approvedDate,
    });

    // show modal
    const show = () => {
      approvementModal.value?.show();
    };

    // hide modal
    const hide = () => {
      approvementModal.value?.hide();
    };

    const submitClick = () => {
      form.value?.submitForm();
    };

    const validated = (approvementData: ApprovementForm) => {
      context.emit('validated', approvementData);
      hide();
    };

    const clearForm = () => {
      form.value?.clearForm();
    };

    return {
      approvementModal,
      form,
      isLoading,
      approvementForm,
      show,
      hide,
      submitClick,
      validated,
      clearForm,
    };
  },
});
